import * as z from "zod";

export const updateLinearTicketStatus = {
  name: "updateLinearTicketStatus" as const,
  input: z.object({
    linearTicketId: z.string(),
    newStateId: z.string(),
    newStateName: z.string(),
  }),
  output: z.object({
    success: z.boolean(),
    newStateName: z.string().nullable(),
    error: z.string().nullable().optional(),
  }),
};
